/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * This code may be used, reproduced, modified, or distributed ONLY with the
 * prior written permission of Aegis AO Soft LLC / Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 */


/*
 * The single "go back" control for page headers. It belongs at the START of the header's right-hand
 * button group — same place and same look as BackToBookingButton on the Drivers page — so the header
 * never grows a second, differently-styled back arrow on the left.
 */

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';

export interface BackButtonProps {
  onClick: () => void;
  /** Defaults to the generic "Back"; pass a destination-specific label where the page knows it. */
  label?: string;
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick, label, className }) => {
  const { t } = useTranslation();
  const text = label ?? t('common.back', 'Back');

  return (
    <Button variant="outline" className={className} onClick={onClick} title={text}>
      <ArrowLeft className="h-4 w-4" />
      <span className="hidden md:inline ml-1">{text}</span>
    </Button>
  );
};
